module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAARCAYAAADQWvz5AAAAAXNSR0IArs4c6QAAAPFJREFUOBFj/A8EDGSA979/MvCxsDEwMzKCdbOQasaPf38ZZj66xnDzywcGflY2hgJFPQZxNk4GJlIMAhky+cEVsCEgfR9//2I48PYZ2AiiDYIZcv/bJxS7+YHeAwGiDMJliAo3P4OziDRxBuEzJFteh4GVEeIWvC4iZAg7E0I7ggV2IIIgxRCQLqwGkWoIVoPIMQTDIHINQTGIEkPgBv36/w+cYtETGyidgKIYOXZAmrABcGDvefOEgRJDQAaDDfr85zeKJaS4BKYRbJCTsDSDEBsHWEybV4ho78AMAdGMsPIIVCh9/fubgYeZFVmeaDYA5q+KLRdvWD4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/pan.png
// module id = i4EC
// module chunks = 1